import React from 'react';

import { TMcsaWorldKey } from '../../../../types/mcsa.interface';

interface JourneyWorldIconProps {
    worldKey: TMcsaWorldKey;
}

export const JourneyWorldIcon = (props: JourneyWorldIconProps) => {
    const { worldKey } = props;

    return (
        <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
            {worldKey === 'cur' && <path d='M22 12h-4l-3 9L9 3l-3 9H2' />}
            {worldKey === 'travel' && (
                <path d='M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z' />
            )}
            {worldKey === 'shop' && (
                <>
                    <path d='M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z' />
                    <path d='M3 6h18' />
                    <path d='M16 10a4 4 0 0 1-8 0' />
                </>
            )}
            {worldKey === 'hobby' && (
                <>
                    <circle cx='13.5' cy='6.5' r='1.5' />
                    <circle cx='17.5' cy='10.5' r='1.5' />
                    <circle cx='8.5' cy='7.5' r='1.5' />
                    <circle cx='6.5' cy='12.5' r='1.5' />
                    <path d='M12 2C6.5 2 2 6 2 11a5 5 0 0 0 5 5h1.8a2 2 0 0 1 1.4 3.4 2 2 0 0 0 1.4 3.4C17.5 22.8 22 18 22 12A10 10 0 0 0 12 2Z' />
                </>
            )}
            {worldKey === 'mingle' && (
                <>
                    <path d='M16 21v-2a4 4 0 0 0-3-3.87' />
                    <path d='M17 3.13a4 4 0 0 1 0 7.75' />
                    <path d='M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z' />
                    <path d='M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2' />
                </>
            )}
            {worldKey === 'online' && (
                <>
                    <circle cx='12' cy='12' r='10' />
                    <path d='M2 12h20' />
                    <path d='M12 2a15.3 15.3 0 0 1 0 20 15.3 15.3 0 0 1 0-20' />
                </>
            )}
        </svg>
    );
};
